<!--
    课程中心
    功能：课程中心数据
    说明：旧版本
-->
<template>
  <div class="goods school-center-padding">
    <el-row
      v-if="showPay"
      style="padding: 24px 0; border-bottom: 1px solid #E4E7ED;"
    >
      <el-button class="btn-gray" @click="$router.push('/account/list')">充 值</el-button>
    </el-row>

    <AppList
      ref="list"
      :list.sync="list"
      title=""
      :create-label="'我的订单'"
      @create="$router.push('/myClass/myOrder?page=1&per_page=10&order[id]=desc')"
      :api="api"
    >
      <AppSearch
        v-if="listLen || $store.state.appId === 4"
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <ul v-if="props.listData && props.listData.length" class="goods-ul">
          <li class="goods-li" v-for="item in props.listData" :key="item.id" @click="showDetail(item.id)">
            <div class="goods-head pr">
              <img :src="item.image || item.cover || noCover">
              <div v-if="item.video" class="goods-video">
                <div class="video-btn" @click.stop="showVideo(item.name, item.video)"></div>
              </div>
            </div>

            <div class="goods-foot flex ac jb">
              <h3 class="goods-title elps">{{item.name}}</h3>
              <el-popover
                v-if="item.detail && item.introduction"
                width="212"
                offset="10"
                placement="top-start"
                popper-class="goods-tip-con"
                trigger="hover"
              >
                <figure>
                  <h4>主要介绍</h4>
                  <div v-html="item.detail.replace(/iframe/g, 'video').replace(/<video/g, '<video controls').replace(/(<img|<video)/, '$1 style=display:block; ')" class="goods-tip-rec-detail"></div>
                </figure>
                <figure>
                  <h4 class="goods-tip-rec-class">课程包简介</h4>
                  <p>{{item.introduction}}</p>
                </figure>
                <i slot="reference" class="goods-tip el-icon-warning-outline"/>
              </el-popover>
            </div>
          </li>
        </ul>
        <div v-else class="goods-empty flex dc ac jc">
          <i></i>
          <p>暂无数据</p>
        </div>
      </template>
    </AppList>

    <el-dialog
      :title="videoData.title"
      class="dialog-sp1 dialog-video"
      :visible.sync="videoData.show"
      @opened="videoOpen"
      @close="videoClose"
      width="692px">
      <video ref="ref_video" :src="videoData.src" controls="controls" width="100%"></video>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../assets/reset.scss';
  @import "index.scss"
</style>



// WEBPACK FOOTER //
// src/views/Goods/index.vue